export default __webpack_public_path__ + "79d1f8ebbc88ee51916338b1fa177c72.gif";